import { categories } from '@/mocks/categories';

function CategoryCard({ cat }: { cat: typeof categories[0] }) {
  return (
    <a
      href={cat.url}
      target="_blank"
      rel="noopener nofollow"
      className="group block bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[4/3] overflow-hidden bg-background-100">
        <img
          src={cat.imageUrl}
          alt={`${cat.name} AllChinaBuy Spreadsheet Category`}
          title={`AllChinaBuy Spreadsheet ${cat.name} Category`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
          {cat.name}
        </h3>
        <p className="text-foreground-500 text-xs md:text-sm mt-1 flex items-center gap-1">
          Browse {cat.name.toLowerCase()} collection
          <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
        </p>
      </div>
    </a>
  );
}

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs md:text-sm text-foreground-500 font-medium uppercase tracking-wider mb-2">
          Shop by Category
        </p>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
          All Product Categories
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-xl mb-10">
          Explore our complete collection of 14 curated product categories. Each section connects you directly to organized seller listings and product spreadsheets on KASpreadsheet.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <CategoryCard key={cat.name} cat={cat} />
          ))}
        </div>
      </div>
    </section>
  );
}